var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndentArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72 13.78a.75.75 0 001.06 0l4-4a.75.75 0 000-1.06l-4-4a.75.75 0 10-1.06 1.06L9.44 8.5H3A1.5 1.5 0 011.5 7V.75a.75.75 0 00-1.5 0V7a3 3 0 003 3h6.44l-2.72 2.72a.75.75 0 000 1.06z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndentArrow);
export default ForwardRef;